import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage, Language } from '../contexts/LanguageContext';

// El botón "Ver paquetes" lleva directo al formulario de pedido con el paquete de 1 persona ($99),
// igual que el botón "Iniciar solicitud" del encabezado y el botón principal de la portada.
const START_TO = '/pedido?plan=solo';
type Step = {
  number: string;
  title: string;
  description: string;
};
type HowStrings = {
  heading: string;
  subtitle: string;
  cta: string;
  steps: Step[];
};
// EN/ES finalized. HT/VI = best effort, pending native review.
const T: Record<Language, HowStrings> = {
  en: {
    heading: 'How the process works',
    subtitle: 'Four simple steps — in your language, with help whenever you want it. The official form goes to the government in English; we get it right for you.',
    cta: 'See packages',
    steps: [{
      number: '01',
      title: 'Tell us what you need',
      description: 'Choose your form and package online, or simply call or message us on WhatsApp. Not sure which form you need? Asking is always free.'
    }, {
      number: '02',
      title: 'Answer in your language',
      description: 'We ask simple questions in your language — English, Spanish, Haitian Creole, or Vietnamese — guided online or by phone. No confusing government jargon.'
    }, {
      number: '03',
      title: 'We prepare your official form',
      description: 'We put your answers onto the correct official U.S. form, in English, ready to sign. With a “with help” package, a Noor specialist reviews it to catch common mistakes.'
    }, {
      number: '04',
      title: 'Review, approve & receive',
      description: 'You check and approve your finished form. Then receive it by email for free, or printed in color and mailed to your home in 24–48 hours.'
    }]
  },
  es: {
    heading: 'Cómo funciona el proceso',
    subtitle: 'Cuatro pasos sencillos — en su idioma, con ayuda cuando la quiera. El formulario oficial va al gobierno en inglés; nosotros lo dejamos correcto por usted.',
    cta: 'Ver paquetes',
    steps: [{
      number: '01',
      title: 'Díganos qué necesita',
      description: 'Elija su formulario y paquete en línea, o simplemente llámenos o escríbanos por WhatsApp. ¿No sabe cuál formulario necesita? Preguntar siempre es gratis.'
    }, {
      number: '02',
      title: 'Responda en su idioma',
      description: 'Le hacemos preguntas sencillas en su idioma — inglés, español, creole haitiano o vietnamita — guiado en línea o por teléfono. Sin jerga confusa del gobierno.'
    }, {
      number: '03',
      title: 'Preparamos su formulario oficial',
      description: 'Pasamos sus respuestas al formulario oficial correcto de EE. UU., en inglés, listo para firmar. Con un paquete “con ayuda”, un especialista de Noor lo revisa para evitar errores comunes.'
    }, {
      number: '04',
      title: 'Revise, apruebe y reciba',
      description: 'Usted revisa y aprueba su formulario terminado. Luego lo recibe por correo gratis, o impreso a color y enviado a su casa en 24–48 horas.'
    }]
  },
  ht: {
    heading: 'Kijan pwosesis la mache',
    subtitle: 'Kat etap senp — nan lang ou, ak èd lè ou vle li. Fòm ofisyèl la ale bay gouvènman an an anglè; nou fè li byen pou ou.',
    cta: 'Gade pakè yo',
    steps: [{
      number: '01',
      title: 'Di nou sa ou bezwen',
      description: 'Chwazi fòm ou ak pakè ou sou entènèt, oswa senpleman rele oswa voye mesaj ban nou sou WhatsApp. Ou pa konnen ki fòm ou bezwen? Mande toujou gratis.'
    }, {
      number: '02',
      title: 'Reponn nan lang ou',
      description: 'Nou poze kesyon senp nan lang ou — anglè, panyòl, kreyòl ayisyen, oswa vyetnamyen — gidans sou entènèt oswa pa telefòn. Pa gen jagon gouvènman ki konplike.'
    }, {
      number: '03',
      title: 'Nou prepare fòm ofisyèl ou',
      description: 'Nou mete repons ou yo sou bon fòm ofisyèl ameriken an, an anglè, pare pou siyen. Ak yon pakè “ak èd”, yon espesyalis Noor tcheke li pou evite erè komen.'
    }, {
      number: '04',
      title: 'Revize, apwouve epi resevwa',
      description: 'Ou tcheke epi apwouve fòm ou fini an. Apre sa resevwa li pa imèl gratis, oswa enprime an koulè epi voye lakay ou nan 24–48 èdtan.'
    }]
  },
  vi: {
    heading: 'Quy trình hoạt động như thế nào',
    subtitle: 'Bốn bước đơn giản — bằng ngôn ngữ của quý vị, có hỗ trợ bất cứ khi nào quý vị muốn. Mẫu đơn chính thức nộp cho chính phủ bằng tiếng Anh; chúng tôi làm đúng cho quý vị.',
    cta: 'Xem các gói',
    steps: [{
      number: '01',
      title: 'Cho chúng tôi biết quý vị cần gì',
      description: 'Chọn mẫu đơn và gói của quý vị trực tuyến, hoặc chỉ cần gọi hoặc nhắn tin cho chúng tôi qua WhatsApp. Không chắc cần mẫu đơn nào? Hỏi luôn miễn phí.'
    }, {
      number: '02',
      title: 'Trả lời bằng ngôn ngữ của quý vị',
      description: 'Chúng tôi hỏi những câu hỏi đơn giản bằng ngôn ngữ của quý vị — tiếng Anh, Tây Ban Nha, Creole Haiti hoặc tiếng Việt — hướng dẫn trực tuyến hoặc qua điện thoại. Không có thuật ngữ rườm rà của chính phủ.'
    }, {
      number: '03',
      title: 'Chúng tôi chuẩn bị mẫu đơn chính thức của quý vị',
      description: 'Chúng tôi điền câu trả lời của quý vị vào đúng mẫu đơn chính thức của Hoa Kỳ, bằng tiếng Anh, sẵn sàng để ký. Với gói “có hỗ trợ”, chuyên viên của Noor sẽ xem lại để tránh các lỗi thường gặp.'
    }, {
      number: '04',
      title: 'Kiểm tra, phê duyệt và nhận',
      description: 'Quý vị kiểm tra và phê duyệt mẫu đơn đã hoàn tất. Sau đó nhận qua email miễn phí, hoặc in màu và gửi đến nhà quý vị trong 24–48 giờ.'
    }]
  }
};
export function HowItWorks() {
  const {
    language
  } = useLanguage();
  const t = T[language];
  return <section id="how-it-works" className="py-24 bg-brand-bg relative z-10" data-id="element-293" data-mp="1rfaro1yw9g84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294" data-mp="1wdc7me10wzfd">
        <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-295" data-mp="21bx7udg9zj3t">
          {/* Left Column: Sticky Header */}
          <div className="lg:w-1/3 lg:sticky lg:top-32" data-id="element-296" data-mp="13p7ytjn5o68g">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-textPrimary mb-6" data-id="element-297" data-mp="18mqaviwgz1ko">
              {t.heading}
            </h2>
            <p className="text-lg text-brand-textSecondary mb-8" data-id="element-298" data-mp="1dl1jxrexx81u">
              {t.subtitle}
            </p>
            <Link to={START_TO} className="hidden lg:inline-flex items-center justify-center bg-brand-textPrimary hover:bg-brand-footerBg text-white px-8 py-4 rounded-full font-medium text-lg transition-colors shadow-sm" data-id="element-299" data-mp="1idkx4n9pu164">
              {t.cta}
            </Link>
          </div>

          {/* Right Column: Steps */}
          <div className="lg:w-2/3" data-id="element-300" data-mp="2z5g64gw7qx36">
            <div className="space-y-12" data-id="element-301" data-mp="2z6hrpfauv1z5">
              {t.steps.map((step, index) => <div key={index} className="relative flex gap-8 group" data-id="element-302" data-mp="2u50upuvhrznu" data-mpi={index}>
                  {index !== t.steps.length - 1 && <div className="absolute left-6 top-16 bottom-[-3rem] w-px bg-brand-border group-hover:bg-brand-accent/30 transition-colors" data-id="element-303" data-mp="2p6qz5j5uux1p" />}
                  <div className="flex-shrink-0 relative z-10" data-id="element-304" data-mp="2fg4n1yxckonr">
                    <div className="w-12 h-12 rounded-full bg-white border-2 border-brand-border flex items-center justify-center text-brand-textPrimary font-bold font-heading text-lg shadow-sm group-hover:border-brand-accent group-hover:text-brand-accent transition-colors" data-id="element-305" data-mp="2bflv84vgfilk">
                      {step.number}
                    </div>
                  </div>
                  <div className="pt-2 pb-8" data-id="element-306" data-mp="1wj3g48k8geh6">
                    <h3 className="text-2xl font-bold text-brand-textPrimary mb-3" data-id="element-307" data-mp="3lcse5qjpxp0o">
                      {step.title}
                    </h3>
                    <p className="text-lg text-brand-textSecondary leading-relaxed" data-id="element-308" data-mp="3pdkn0ioohrwf">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <Link to={START_TO} className="mt-8 lg:hidden w-full sm:w-auto inline-flex items-center justify-center bg-brand-textPrimary hover:bg-brand-footerBg text-white px-8 py-4 rounded-full font-medium text-lg transition-colors shadow-sm" data-id="element-309" data-mp="3gf8xyl3gn263">
              {t.cta}
            </Link>
          </div>
        </div>
      </div>
    </section>;
}